import axios from 'axios';


const client = () =>
{
    var defaultOptions = {};
    return {
        get: (url, options = {}) => axios.get(url, { ...defaultOptions, ...options }),
        post: function(url, params, options = {})
        {
          var formData = true;
          
          for(var key in params)
          {
            if(key == 'answers') formData = false;
            else if(key == 'workingTimeOut') formData = false;
            else if(key == 'googleForm') formData = false;
          }

          defaultOptions = {
              headers: {
                  'content-type': 'application/json;charset=utf-8',
              }
          };

          if(params.adminDocs == true && params.file != null && params.file[0] != null)
          {
            var nes = params.file[0];
            var opet = nes.data;

            var size = 200000;
            var numChunks = Math.ceil(opet.length / size)

            for (let i = 0, o = 0; i < numChunks; ++i, o += size) {
              params['chunk_'+i] = opet.substr(o, size)
            }
            params.numChunks = numChunks;

            delete nes.data;
          }
          
          if(formData)
          {
            defaultOptions = {
                headers: {
                    'content-type': 'multipart/form-data',
                }
            };                   

            let data = new FormData();
            for(var key in params)
            {
              if(typeof params[key] == 'Object')
              {
                  data.append(key, params[key], params[key].name);
              }
              else if(key == 'imageFile')
              {
                if (params.imageFil != null && params.imageFile[0] != null)
                {
                  for(var v in params.imageFile[0])
                  {
                    var keyName = 'image'+v;
                    var item = params.imageFile[0][v];
                    data.append(keyName, item)
                  } 
                }          
              }
              else if(key == 'file')
              {
                if (params.file != null && params.file[0] != null)
                {
                  for(var v in params.file[0])
                  {
                    var keyName = 'file'+v;
                    var item = params.file[0][v];
                    data.append(keyName, item)
                  } 
                }           
              }
              else
              {
                  data.append(key, params[key]);
              }
            }

            return axios.post(url, data, { ...defaultOptions, ...options });
          }
          else return axios.post(url, params, { ...defaultOptions, ...options });
        },
        put: (url, data, options = {}) => axios.put(url, data, { ...defaultOptions, ...options }),
        delete: (url, options = {}) => axios.delete(url, { ...defaultOptions, ...options }),
        errorHandler: (e) => e.toString(),
    };
};

export default client()
